export default __webpack_public_path__ + "9f90b41041eb6902d9f23a88b127db39.png";